export default __webpack_public_path__ + "static/media/Green geode1.54dfab84.jpg";